/**
 * Exports carousel-related design tokens
 */

export const slideChangeIntervalMs = 2000;